// 正则匹配手机号
const regMobile = function (mobile) {
  if (!mobile) {
    return false;
  }

  if (mobile.length === 11) {
    return true;
  }

  return false;
};

// 手机号分割
const telSplit = (_val) => {
  let val = _val;

  if (!val) {
    return '';
  }

  val = val.toString();

  if (val.length <= 3) {
    return val;
  }

  val = val.replace(/\s/g, ''); // 去掉所有空格
  const firstThreeChar = val.slice(0, 3); // 获取前三个字符
  val = val.replace(/^(\w{3})/, ''); // 去掉前三个字符
  val = val.replace(/(\w{4})/g, '$1 '); // 添加间隔
  val = firstThreeChar + " " + val;

  return val;
};

// 手机号加密
const telSecret = (tel) => {
  if (!tel) {
    return '';
  }

  const secretTel = tel.replace(/^(\w{3})(\w{4})/, '$1****');
  return secretTel;
};

// 匹配是否中文
const isChineseChar = (text) => {
  const reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/;
  return reg.test(text);
};

// 去掉中文
const cutChinese = (text) => {
  return text.split('').filter((item) => {
    if (isChineseChar(item)) {
      return false;
    }
    return true;
  }).join('');
};

// 开始截取, 一直截取到第一个中文
const cutFromFirstChinese = (text) => {
  if (isChineseChar(text) === false) {
    return text;
  }

  const textList = text.split('');
  let index = 0;

  for (let i = 0; i < textList.length; i++) {
    if (isChineseChar(textList[i])) {
      index = i;
      break;
    }
  }

  return text.substring(0, index);
};

// 开始截取, 一直截取到第一个非数字
const cutFromFirstNoNumber = (text) => {
  if (isNaN(text) === false) {
    return text;
  }

  const textList = text.split('');
  let index = 0;

  for (let i = 0; i < textList.length; i++) {
    if (isNaN(textList[i])) {
      index = i;
      break;
    }
  }

  return text.substring(0, index);
};

const regInt = (val) => {
  return /(^[1-9]\d*$)/.test(val);
};

const regEmail = (val) => {
  return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(val);
};

const regWechat = (val) => {
  return /^[a-zA-Z0-9]{1}[-_a-zA-Z0-9]{5,19}$/.test(val);
}

export default {
  regMobile,
  telSplit,
  telSecret,
  isChineseChar,
  cutChinese,
  cutFromFirstChinese,
  cutFromFirstNoNumber,
  regInt,
  regEmail,
  regWechat,
};
